/** URL stores presentation position, never completion/mastery. Clamp after content changes. */
export function initialLearnerPage(total:number){
 const value=typeof window==='undefined'?1:Number(new URLSearchParams(window.location.search).get('page')??1);
 return Number.isInteger(value)?Math.max(0,Math.min(total-1,value-1)):0;
}
